module.exports = __webpack_public_path__ + "img/cases-brand-tommee-8.e91b0c51.jpg";